export var defaultProps = {
  as: "a",
  className: null,
  selected: false
};